import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=1963c603&scoped=true&"
import script from "./RecipeView.vue?vue&type=script&lang=js&"
export * from "./RecipeView.vue?vue&type=script&lang=js&"
import style0 from "./RecipeView.vue?vue&type=style&index=0&id=1963c603&scoped=true&lang=css&"
import style1 from "./RecipeView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963c603",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1963c603')) {
      api.createRecord('1963c603', component.options)
    } else {
      api.reload('1963c603', component.options)
    }
    module.hot.accept("./RecipeView.vue?vue&type=template&id=1963c603&scoped=true&", function () {
      api.rerender('1963c603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeView.vue"
export default component.exports